module.exports = __webpack_public_path__ + "static/media/Wechat.df8594e2.jpeg";